export default "__VITE_PUBLIC_ASSET__cad53164__"